import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
// namespace SlotGames2 {
	export class TikiBay2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();
	}
	
// }
